// Resources page — client-side search filtering and tab switching
// Avoids inline script CSP violations

function initResourcesPage () {
  const searchInput = document.getElementById('resource-search')
  const faqItems = document.querySelectorAll('.faq-item')
  const noResults = document.getElementById('no-faq-results')
  if (!searchInput || !faqItems.length) return
  if (searchInput.dataset.initialized) return
  searchInput.dataset.initialized = 'true'

  searchInput.addEventListener('input', function (e) {
    const query = e.target.value.toLowerCase().trim()
    let visibleCount = 0

    faqItems.forEach(item => {
      const q = item.querySelector('.faq-question')?.textContent.toLowerCase() || ''
      const a = item.querySelector('.faq-answer')?.textContent.toLowerCase() || ''

      if (q.includes(query) || a.includes(query)) {
        item.classList.remove('hidden')
        visibleCount++
        if (query.length > 0) item.setAttribute('open', '')
      } else {
        item.classList.add('hidden')
      }
    })

    if (noResults) {
      noResults.classList.toggle('hidden', visibleCount > 0)
    }
  })

  const tabs = document.querySelectorAll('#resource-tabs .tab-btn')
  tabs.forEach(tab => {
    tab.addEventListener('click', function () {
      tabs.forEach(t => {
        t.classList.remove('bg-[#043f42]', 'text-white', 'font-semibold')
        t.classList.add('bg-gray-100', 'text-gray-700', 'font-medium')
      })
      this.classList.add('bg-[#043f42]', 'text-white', 'font-semibold')
      this.classList.remove('bg-gray-100', 'text-gray-700', 'font-medium')
    })
  })
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initResourcesPage)
} else {
  initResourcesPage()
}
document.addEventListener('turbo:load', initResourcesPage)
